import { Fragment, React, useRef, useState } from "react";
import { useEffect } from "react";
import * as d3 from "d3";
import _ from "lodash";
// import { OOSDt } from "./OOSData";
import "./OOS.css";
import { useSelector } from "react-redux";
import { sampleDataWithSingleBubble } from "./SampleData/OOSDataSingle";

const Margin = { LEFT: 30, RIGHT: 0, TOP: 12, BOTTOM: 18 };
const fontSize = "16px";

const OOSWidget = (
  svgElement,
  widgetId,
  _Height,
  Width,
  slots,
  xAxisMax,
  wonDollarValue,
  salesPersons,
  collorPallet,
  showHighVisibilityCallouts
) => {
  let Height = _Height;
  let colors = [
    "#5f8b95",
    "#ba4d51",
    "#af8a53",
    "#955f71",
    "#859666",
    "#7e688c",
    "#91bdc7",
    "#ec7f83",
    "#e1bc85",
    "#c791a3",
    "#b7c898",
    "#B09ABE",
    "#2D5963",
    "#881B1F",
    "#7D5821",
    "#632D3F",
    "#536434",
    "#4C365A",
  ];

  colors.forEach(function (d) {
    colors.push(d);
  });

  if (collorPallet.length > 0) {
    colors = collorPallet;
  }

  let legends = {
    text: wonDollarValue,
    salesPerson: [...salesPersons],
  };

  //generate legend
  const getLegend = legendGenerator(colors, legends);
  document.getElementById(`${widgetId}-dom-legend`).innerHTML = `${getLegend}`;
  const tooltip = d3.select("#tooltip-oos");

  const legend = document.getElementById(`${widgetId}-dom-legend`);

  Height = _Height - legend.clientHeight - 1;

  const svg = svgElement;
  svg.attr("height", Height + Margin.BOTTOM + Margin.TOP + Margin.TOP);
  svg.attr("style", "margin-top: -12px;");
  const x1Scale = d3.scaleLinear().domain([0, xAxisMax]).range([0, Width]);
  const yScale = d3.scaleBand(); //.paddingInner(0.1); //.paddingOuter(0.1);
  const xScale = d3.scaleBand(); //.paddingInner(0.1).paddingOuter(0.1);
  const y1Scale = d3.scaleLinear().domain([0, Height]).range([Height, 0]);
  let maxDollarValue_op = 0;

  // Remove Old Graph
  svg.selectAll("g").remove();
  svg.selectAll("text").remove();

  const dollarValueScale = d3
    .scaleLinear()
    .domain([4500, 13000])
    .range([37, 55]);

  const radiusScale = d3.scaleSqrt().domain([0, 13000]).range([37, 55]);
  const barLineScale = d3.scaleLinear().domain([10, 100]).range([1, 10]);

  const barGroup = svg
    .append("g")
    .attr("class", "bar")
    .attr("transform", `translate(${Margin.LEFT},${Margin.TOP})`);

  //draw x-axis back ground color
  const xAxisLowerPart = svg
    .append("g")
    .attr("class", "x-axis-lower")
    .attr("transform", `translate(${Margin.LEFT},${Margin.TOP})`);

  const yAxisGroup = svg
    .append("g")
    .attr("class", "y-axis-oos")
    .attr("transform", `translate(${Margin.LEFT},${Margin.TOP})`);

  const xAxisGroup = svg
    .append("g")
    .attr("class", "x-axis-oos")
    .attr("transform", `translate(${Margin.LEFT},${Height + Margin.TOP})`);

  const x1AxisGroup = svg
    .append("g")
    .attr("class", "x1-axis")
    .attr("transform", `translate(0,${Height})`);

  const y1AxisGroup = svg
    .append("g")
    .attr("class", "y1-axis")
    .attr("transform", `translate(${Margin.LEFT},${Margin.TOP})`);

  const activityBarGroup = svg
    .append("g")
    .attr("class", "activity-bar")
    .attr("transform", `translate(${Margin.LEFT},${Margin.TOP})`);

  const bubbleGroup = svg
    .append("g")
    .attr("class", "bubble-entity")
    .attr("transform", `translate(${Margin.LEFT},${Margin.TOP})`);

  const text = svg
    .append("text")
    .attr("x", 0)
    .attr("y", Height / 2)
    .attr("dy", ".35em");

  function drawChart(data, stages) {
    let plotWidth = Width;

    const uniqueSalesPersonCount = new Set(
      data
        .flatMap((stage) => stage.bubbles.map((bubble) => bubble.salesPerson))
        .filter((name) => name !== undefined && name !== null && name !== "")
    ).size;

    const minslotValue = d3.min(
      data.map((x) => {
        return d3.min(x.bubbles.map((x) => x.activityCount));
      })
    );

    const maxslotValue = d3.max(
      data.map((x) => {
        return d3.max(x.bubbles.map((x) => x.activityCount));
      })
    );

    const minDollarValue = d3.min(
      data.map((x) => {
        return d3.min(x.bubbles.map((x) => x.dollarValue));
      })
    );

    const maxDollarValue = d3.max(
      data.map((x) => {
        return d3.max(x.bubbles.map((x) => x.dollarValue));
      })
    );

    maxDollarValue_op = maxDollarValue;

    barLineScale.domain([minslotValue, maxslotValue]);

    //yScale.domain(data.map((x) => x.stageName)).range([0, Height]);
    yScale.domain(stages).range([0, Height]);

    dollarValueScale
      .domain([minDollarValue, maxDollarValue])
      .range([yScale.bandwidth() / 2, (yScale.bandwidth() / 2) * 1.5]);

    xScale
      //.domain(["0-30 days", "31-60 days", "61-90 days", ">90 days"])
      .domain(slots)
      .range([0, Width]);

    const yAxisCaller = yAxisGroup.call(
      d3.axisLeft(yScale).tickSizeInner(0).tickSizeOuter(0)
    );
    const xAxisCaller = xAxisGroup.call(
      d3.axisBottom(xScale).tickSizeInner(0).tickSizeOuter(0).tickPadding(10)
    );

    //const x1AxisCaller = x1AxisGroup.call(d3.axisBottom(x1Scale));

    //const y1AxisCaller = y1AxisGroup.call(d3.axisLeft(y1Scale));

    let getMaxTspan = 0;

    yAxisCaller
      .selectAll("text")
      .attr("transform", "rotate(-90)")
      .style("text-anchor", "middle")
      .style("color", "#ffffff")
      .style("font-size", "16px")
      .style("font-weight", "500")
      .call(wrap, yScale.bandwidth() - 10); //minus value donated as padding to text

    yAxisCaller.selectAll(".tick").attr("transform", (d, i, el) => {
      const tspanLength = d3.select(el[i]).selectAll("text tspan")
        ._groups[0].length;

      if (tspanLength > getMaxTspan) {
        getMaxTspan = tspanLength;
      }

      //calculation depend on the font-size of label e.g. 16
      return `translate(${tspanLength > 1 ? -16 * tspanLength : -16},${yScale(d) + yScale.bandwidth() / 2 - 4
        })`;
    });

    yAxisCaller.attr(
      "transform",
      `translate(${getMaxTspan * 16 + 18},${Margin.TOP})`
    );

    var element = d3.select(".y-axis-oos").node();
    const yAxisWidth = element.getBoundingClientRect().width + 5;

    //update x-axis
    xScale
      //.domain(["0-30 days", "31-60 days", "61-90 days", ">90 days"])
      .domain(slots)
      .range([0, Width - Math.abs(Margin.LEFT - yAxisWidth)]);

    plotWidth = xScale.range()[1];

    const xAxisCaller1 = xAxisGroup.call(
      d3.axisBottom(xScale).tickSizeInner(0).tickSizeOuter(0).tickPadding(10)
    );

    xAxisCaller1.attr(
      "transform",
      `translate(${Margin.LEFT + Math.abs(Margin.LEFT - yAxisWidth)},${Height + Margin.TOP
      })`
    );

    const boxData1 = [];
    for (let index = 0; index < stages.length; index++) {
      const stage = stages[index];
      const stageIndex = stages.length - 1 - index;
      for (let index = 0; index < slots.length; index++) {
        const slot = slots[index];

        //collect and process data
        // Step 1: Find the matching element with the corresponding stageName
        const matchingElement = data.find((x) => x.stageName === stage);

        // Step 2: If a matching element exists, filter its bubbles
        const data1 = matchingElement
          ? matchingElement.bubbles.filter(
            (d) => d["x-axis"] === slot.toString()
          )
          : []; // Default to an empty array if no match is found
        boxData1.push({
          stageName: stage,
          slot: slot,
          stageIndex: stageIndex,
          bubbles: data1,
          bubblesCount: data1.length,
        });
      }
    }

    const boxData = [...boxData1].sort(function (a, b) {
      return b.bubblesCount - a.bubblesCount;
    });


    //horizontal lines
    const _xArea = d3
      .select(".x-axis-oos")
      .append("g")
      .attr("class", "vertical-line-container")
      .selectAll("vertical-line")
      //.data(["0-30 days", "31-60 days", "61-90 days", ">90 days"]);
      .data(slots);
    _xArea.exit().remove();

    _xArea
      .enter()
      .append("line")
      .attr("class", "vertical-line")
      .attr("x1", (d, i) => {
        return xScale(d) + xScale.bandwidth();
      })
      .attr("x2", (d, i) => xScale(d) + xScale.bandwidth())
      .attr("y1", (d) => 0)
      .attr("y2", (d) => -Height)
      .attr("stroke", "#BFBFBF")
      .attr("fill", "#BFBFBF")
      .attr("stroke-width", "3")
      .style("stroke-dasharray", "10,5,1,5")
      .attr("shape-rendering", "crispEdges");

    //update x-axis linear scale
    const range_width = Width + Margin.LEFT;
    x1Scale.range([
      Margin.LEFT + Math.abs(Margin.LEFT - yAxisWidth),
      range_width,
    ]);

    //const x1AxisCaller1 = x1AxisGroup.call(d3.axisBottom(x1Scale));

    //console.log("x1Scale(10)", x1Scale(10) - Margin.LEFT);

    //xAxisLowerPart
    const lowerRect = xAxisLowerPart;

    //remove
    lowerRect.exit().remove();

    //update
    lowerRect
      .attr("y", Height)
      .attr("x", (d) => {
        return -yAxisWidth;
      })
      .attr("height", (d) => {
        return "30";
      })
      .attr("width", Width + yAxisWidth)
      .attr("fill", "#BFBFBF")
      .attr("shape-rendering", "crispEdges");

    //create
    lowerRect
      .append("rect")
      .attr("y", Height)
      .attr("x", (d) => {
        return -Margin.LEFT;
      })
      .attr("height", (d) => {
        return "30";
      })
      .attr("width", Width + Margin.LEFT + 1)
      .attr("fill", "#BFBFBF")
      .attr("shape-rendering", "crispEdges");

    lowerRect
      .append("text")
      .attr("x", -yAxisWidth / 2 + Math.abs(Margin.LEFT - yAxisWidth))
      .attr("y", Height + 20)
      .text("AGE")
      .attr("font-size", "14px")
      .style("font-weight", "bold")
      .attr("text-anchor", "middle")
      .attr("fill", "black");

    const rect = barGroup.selectAll("rect").data(data);

    //remove elaments
    rect.exit().remove();

    //update elements
    rect
      .attr("y", (d) => {
        return yScale(d["stageName"]);
      })
      .attr("x", (d) => {
        return -yAxisWidth;
      })
      .attr("height", (d) => {
        return yScale.bandwidth();
      })
      .attr("width", Width + yAxisWidth)
      .attr("fill", (d, i) => {
        if (d["stageName"].toLowerCase().indexOf("won") > -1) {
          return "#789440";
        }
        return i % 2 === 0 ? "#3F3F3F" : "#595959";
      })
      .attr("stroke", (d, i) => {
        if (d["stageName"].toLowerCase().indexOf("won") > -1) {
          return "#789440";
        }
        return i % 2 === 0 ? "#3F3F3F" : "#595959";
      });

    //add new elemets
    rect
      .enter()
      .append("rect")
      .attr("y", (d) => {
        return yScale(d["stageName"]);
      })
      .attr("x", (d) => {
        return -yAxisWidth;
      })
      .attr("height", (d) => {
        return yScale.bandwidth();
      })
      .attr("width", Width + yAxisWidth)
      .attr("fill", (d, i) => {
        if (d["stageName"].toLowerCase().indexOf("won") > -1) {
          return "#789440";
        }
        return i % 2 === 0 ? "#3F3F3F" : "#595959";
      })
      .attr("stroke", (d, i) => {
        if (d["stageName"].toLowerCase().indexOf("won") > -1) {
          return "#789440";
        }
        return i % 2 === 0 ? "#3F3F3F" : "#595959";
      });

    //append box container for display bubble group
    const _box = d3
      .select(".x-axis-oos")
      .append("g")
      .attr("class", "bubbles-container")
      .selectAll("box-container")
      // .data(slots);
      .data(boxData);
    _box.exit().remove();

    _box
      .enter()
      .append("g")
      .attr("class", "box-container")
      .attr("x", function (d) {
        return xScale(d.slot);
      })
      .attr("y", function (d, i) {
        const _stageName = stages[d.stageIndex];
        return -(yScale(_stageName) + yScale.bandwidth());
      })
      .attr("transform", (d) => {
        const _stageName = stages[d.stageIndex];
        //return `translate(${xScale(d.slot) - yScale.bandwidth() * 0.05},${-(
        return `translate(${xScale(d.slot)},${-(
          //(yScale(_stageName) + yScale.bandwidth()) //5% of height
          (yScale(_stageName) + yScale.bandwidth() + yScale.bandwidth() * 0.05) //5% of height
        )})`;
      });

    // Dynamic padding based on bubble count
    let dynamicPadding = 2;
    const getSingleElementMaxVal = boxData
      .filter((x) => x.bubblesCount == 1)
      .map((x) => {
        return Math.max(x.bubbles.map((x) => x.dollarValue));
      });
    const singleBubbleMaxVal = Math.max(...getSingleElementMaxVal);

    const calloutRegistry = [];
    let isGlobalCalloutUpdating = false;

    const updateGlobalCallouts = () => {
      if (
        !showHighVisibilityCallouts ||
        calloutRegistry.length === 0 ||
        isGlobalCalloutUpdating
      ) {
        return;
      }

      isGlobalCalloutUpdating = true;

      const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

      const items = [];
      for (let entryIndex = 0; entryIndex < calloutRegistry.length; entryIndex++) {
        const entry = calloutRegistry[entryIndex];

        for (let nodeIndex = 0; nodeIndex < entry.nodes.length; nodeIndex++) {
          const node = entry.nodes[nodeIndex];
          const globalNodeX = node.x + entry.boxOffsetX;
          const globalNodeY = node.y + entry.boxOffsetY;
          const isRightSide = plotWidth - globalNodeX >= globalNodeX;
          const textLines = node.calloutLines || [""];
          const longestLine = textLines.reduce((max, line) => {
            return line.length > max.length ? line : max;
          }, "");

          const labelWidth = clamp(longestLine.length * 6.1 + 10, 90, 300);
          const labelHeight = textLines.length > 1 ? 24 : 14;
          const initialLabelX = globalNodeX + (isRightSide ? 28 : -28);
          const initialLabelY = globalNodeY;

          items.push({
            entryIndex,
            nodeIndex,
            stageIndex: entry.stageIndex,
            slotIndex: entry.slotIndex,
            rowHeight: entry.rowHeight,
            node,
            textLines,
            labelWidth,
            labelHeight,
            globalNodeX,
            globalNodeY,
            isRightSide,
            labelX: clamp(initialLabelX, 8, plotWidth - 8),
            labelY: initialLabelY,
          });
        }
      }

      const getBounds = (item) => {
        const left = item.isRightSide ? item.labelX : item.labelX - item.labelWidth;
        const right = item.isRightSide ? item.labelX + item.labelWidth : item.labelX;
        const top = item.labelY - (item.textLines.length > 1 ? 13 : 10);
        const bottom = top + item.labelHeight;
        return { left, right, top, bottom };
      };

      const intersects = (a, b, padX = 12, padY = 5) => {
        return !(
          a.right + padX < b.left ||
          b.right + padX < a.left ||
          a.bottom + padY < b.top ||
          b.bottom + padY < a.top
        );
      };

      const cellOccupancy = {};
      for (let i = 0; i < items.length; i++) {
        const key = `${items[i].stageIndex}-${items[i].slotIndex}`;
        cellOccupancy[key] = (cellOccupancy[key] || 0) + 1;
      }

      const rowHeight = yScale.bandwidth() + yScale.bandwidth() * 0.1;
      const yOffsets = [-0.35, 0, 0.35];
      const xOffsets = [-0.32, 0, 0.32];
      const candidateAnchors = [];

      for (let stageIndex = 0; stageIndex < stages.length; stageIndex++) {
        const stageName = stages[stageIndex];
        const cellTopY = -(yScale(stageName) + yScale.bandwidth() + yScale.bandwidth() * 0.05);
        const cellCenterY = cellTopY + rowHeight / 2;

        for (let slotIndex = 0; slotIndex < slots.length; slotIndex++) {
          const slotName = slots[slotIndex];
          const cellLeftX = xScale(slotName);
          const cellCenterX = cellLeftX + xScale.bandwidth() / 2;
          const load = cellOccupancy[`${stageIndex}-${slotIndex}`] || 0;

          for (let yi = 0; yi < yOffsets.length; yi++) {
            for (let xi = 0; xi < xOffsets.length; xi++) {
              candidateAnchors.push({
                stageIndex,
                slotIndex,
                load,
                x: cellCenterX + xOffsets[xi] * xScale.bandwidth(),
                y: cellCenterY + yOffsets[yi] * rowHeight,
              });
            }
          }
        }
      }

      const usedAnchorCount = {};
      const placedBounds = [];
      const sortedItems = [...items].sort((a, b) => b.node.radius - a.node.radius);

      const clampLabelX = (item) => {
        if (item.isRightSide) {
          item.labelX = clamp(item.labelX, 8, plotWidth - item.labelWidth - 8);
        } else {
          item.labelX = clamp(item.labelX, item.labelWidth + 8, plotWidth - 8);
        }
      };

      for (let i = 0; i < sortedItems.length; i++) {
        const item = sortedItems[i];
        let bestScore = Number.POSITIVE_INFINITY;
        let bestAnchor = null;

        for (let c = 0; c < candidateAnchors.length; c++) {
          const cand = candidateAnchors[c];
          const candKey = `${cand.stageIndex}-${cand.slotIndex}-${Math.round(cand.x)}-${Math.round(cand.y)}`;
          const used = usedAnchorCount[candKey] || 0;
          const isRightSide = cand.x >= item.globalNodeX;

          const bounds = {
            left: isRightSide ? cand.x : cand.x - item.labelWidth,
            right: isRightSide ? cand.x + item.labelWidth : cand.x,
            top: cand.y - (item.textLines.length > 1 ? 13 : 10),
            bottom: cand.y - (item.textLines.length > 1 ? 13 : 10) + item.labelHeight,
          };

          let overlapCount = 0;
          for (let p = 0; p < placedBounds.length; p++) {
            if (intersects(bounds, placedBounds[p], 8, 4)) {
              overlapCount++;
            }
          }

          const cellDistance =
            Math.abs(cand.slotIndex - item.slotIndex) +
            Math.abs(cand.stageIndex - item.stageIndex) * 1.1;
          const dx = Math.abs(cand.x - item.globalNodeX);
          const dy = Math.abs(cand.y - item.globalNodeY);

          const score =
            dx * 1.0 +
            dy * 1.25 +
            cellDistance * 60 +
            cand.load * 130 +
            used * 320 +
            overlapCount * 1100;

          if (score < bestScore) {
            bestScore = score;
            bestAnchor = {
              cand,
              candKey,
              isRightSide,
              x: cand.x,
              y: cand.y,
            };
          }
        }

        if (!bestAnchor) {
          bestAnchor = {
            isRightSide: true,
            x: clamp(item.globalNodeX + 24, 8, plotWidth - 8),
            y: item.globalNodeY,
          };
        }

        item.isRightSide = bestAnchor.isRightSide;
        item.textAnchor = item.isRightSide ? "start" : "end";
        item.labelX = bestAnchor.x;
        item.labelY = bestAnchor.y;
        clampLabelX(item);

        const itemBounds = getBounds(item);
        placedBounds.push(itemBounds);

        if (bestAnchor.candKey) {
          usedAnchorCount[bestAnchor.candKey] =
            (usedAnchorCount[bestAnchor.candKey] || 0) + 1;
        }
      }

      // Global relaxation pass across all callouts.
      for (let step = 0; step < 36; step++) {
        for (let i = 0; i < sortedItems.length; i++) {
          for (let j = i + 1; j < sortedItems.length; j++) {
            const a = sortedItems[i];
            const b = sortedItems[j];
            const aBounds = getBounds(a);
            const bBounds = getBounds(b);

            if (!intersects(aBounds, bBounds, 8, 4)) {
              continue;
            }

            const dx = (a.labelX - b.labelX) || (a.isRightSide ? 1 : -1);
            const dy = (a.labelY - b.labelY) || 1;
            const len = Math.sqrt(dx * dx + dy * dy) || 1;
            const ux = dx / len;
            const uy = dy / len;

            a.labelX += ux * 10 + (a.isRightSide ? 2 : -2);
            a.labelY += uy * 6;
            b.labelX -= ux * 10 + (b.isRightSide ? 2 : -2);
            b.labelY -= uy * 6;

            clampLabelX(a);
            clampLabelX(b);

            const verticalPadding = yScale.bandwidth() * 1.8;
            a.labelY = clamp(a.labelY, -verticalPadding, Height + verticalPadding);
            b.labelY = clamp(b.labelY, -verticalPadding, Height + verticalPadding);
          }
        }
      }

      const layoutByKey = {};
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        const key = `${item.entryIndex}-${item.nodeIndex}`;
        layoutByKey[key] = item;
      }

      for (let entryIndex = 0; entryIndex < calloutRegistry.length; entryIndex++) {
        const entry = calloutRegistry[entryIndex];

        entry.calloutLines.attr("points", (d, nodeIndex) => {
          const key = `${entryIndex}-${nodeIndex}`;
          const item = layoutByKey[key];
          const localLabelX = item.labelX - entry.boxOffsetX;
          const localLabelY = item.labelY - entry.boxOffsetY;
          // Start from the bubble perimeter in the direction of the label.
          const ux = item.isRightSide ? 1 : -1;
          const lineStartX = d.x + ux * d.radius;
          const lineStartY = d.y;

          // Finish at the geometric center of the callout text block.
          const labelCenterX =
            localLabelX + (item.isRightSide ? item.labelWidth / 2 : -item.labelWidth / 2);
          const labelTopY = localLabelY - (item.textLines.length > 1 ? 13 : 10);
          const labelCenterY = labelTopY + item.labelHeight / 2;
          const lineEndX = labelCenterX;
          const lineEndY = labelCenterY;

          const dx = lineEndX - lineStartX;
          const dy = lineEndY - lineStartY;
          const absDx = Math.abs(dx);
          const absDy = Math.abs(dy);

          // Use a straight segment for short/simple routes to avoid visual noise.
          if (absDy <= 8 || absDx <= 26) {
            return `${lineStartX},${lineStartY} ${lineEndX},${lineEndY}`;
          }

          // Add one controlled elbow only when routing around denser areas.
          const bendDistance = Math.max(12, Math.min(34, absDx * 0.45));
          const elbowX = lineStartX + (item.isRightSide ? bendDistance : -bendDistance);
          const elbowY = lineStartY + dy * 0.7;

          return `${lineStartX},${lineStartY} ${elbowX},${elbowY} ${lineEndX},${lineEndY}`;
        });

        entry.calloutLabels
          .attr("x", (d, nodeIndex) => {
            const item = layoutByKey[`${entryIndex}-${nodeIndex}`];
            const localX = item.labelX - entry.boxOffsetX;
            // Center the anchor point horizontally within the label
            return localX + (item.isRightSide ? item.labelWidth / 2 : -item.labelWidth / 2);
          })
          .attr("y", (d, nodeIndex) => {
            const item = layoutByKey[`${entryIndex}-${nodeIndex}`];
            return item.labelY - entry.boxOffsetY;
          })
          .style("text-anchor", "middle");

        entry.calloutLabels
          .selectAll("tspan")
          .attr("x", function () {
            return d3.select(this.parentNode).attr("x");
          });
      }

      isGlobalCalloutUpdating = false;
    };

    //Create the bubbles
    d3.selectAll(".box-container").each(function (dt, i) {
      const index = i;
      var element = d3.select(this).node();
      var getElementData = d3.select(this).data()[0];
      const _width = xScale.bandwidth(); //+ yScale.bandwidth() * 0.1; //element.getBoundingClientRect().width;
      const _height = yScale.bandwidth() + yScale.bandwidth() * 0.05 * 2; //element.getBoundingClientRect().height;
      const boxOffsetX = xScale(getElementData.slot);

      const bubblesDt = getElementData.bubbles.sort(function (a, b) {
        return a.dollarValue - b.dollarValue;
      });

      const bubbleCount = bubblesDt.length;
      // Dynamic padding based on bubble count
      if (bubbleCount <= 60) {
        dynamicPadding =
          (Math.min(_width, _height) / Math.sqrt(bubbleCount)) * 0.25;
      }


      //calculate only for large number of bubbles count
      if (index === 0) {
        // Calculate dynamic min and max radius
        const availableArea = _width * _height;
        const averageBubbleArea = availableArea / bubbleCount;

        const calclulateTheAvgOfMin =
          bubbleCount >= 1 && bubbleCount <= 4 ? 0.15 : 0.4; // 30% or 40% of the average

        const dynamicMinRadius =
          Math.sqrt(averageBubbleArea / Math.PI) * calclulateTheAvgOfMin; // 40% of the average
        const dynamicMaxRadius = Math.min(
          Math.sqrt(averageBubbleArea / Math.PI) * 1.2, // 120% of the average
          _height / 4, // Limit based on height
          _width / 8 // Limit based on width
        );

        const getMaxVal = Math.max(...bubblesDt.map((x) => x.dollarValue));
        let updatedMaxRadius = dynamicMaxRadius;

        // Define scales dynamically based on data values
        radiusScale.domain([0, maxDollarValue]).range([0, dynamicMaxRadius]);

        if (
          bubbleCount >= 1 &&
          bubbleCount <= 4 &&
          (singleBubbleMaxVal > getMaxVal || singleBubbleMaxVal === getMaxVal)
        ) {

          updatedMaxRadius = yScale.bandwidth() / 2 + yScale.bandwidth() * 0.05;
          //const getUpdatedMinVal = updatedMaxRadius - dynamicMaxRadius;

          radiusScale.range([
            0, //dynamicMinRadius + getUpdatedMinVal * 0.8,
            updatedMaxRadius,
          ]);
        }

        //Handle only single bubble
        if (bubbleCount === 1) {
          updatedMaxRadius = yScale.bandwidth() / 2 + yScale.bandwidth() * 0.05;
          //const getUpdatedMinVal = updatedMaxRadius - dynamicMaxRadius;
          //console.log("updatedMaxRadius", updatedMaxRadius, getUpdatedMinVal);
          radiusScale.domain([0, maxDollarValue]).range([
            0, //dynamicMinRadius + getUpdatedMinVal * 0.8,
            updatedMaxRadius,
          ]);
        }

        //define the min and max size of line bar
        barLineScale.range([dynamicMinRadius / 2, updatedMaxRadius * 1.25]); //min is half of min radius and max is 1.25x of max bubble size
      }

      // Create nodes with radius based on data
      const nodes = bubblesDt.map((d) => ({
        calloutColor:
          colors[
          legends.salesPerson.findIndex(
            (x) => x.toString() === d.salesPerson.toString()
          )
          ] || "#d9d9d9",
        id: d.groupIndex,
        radius: radiusScale(d.dollarValue),
        value: d.dollarValue,
        salesPerson: d.salesPerson,
        text: d.text,
        activityCount: d.activityCount,
        organization: d.organization,
        calloutLines:
          uniqueSalesPersonCount > 1 && d.salesPerson
            ? [
              d.salesPerson,
              `$${new Intl.NumberFormat("en-US").format(d.dollarValue)} | ${d.activityCount
              } Slots`,
            ]
            : [
              `$${new Intl.NumberFormat("en-US").format(d.dollarValue)} | ${d.activityCount
              } Slots`,
            ],
        x: Math.random() * _width,
        y: Math.random() * _height,
      }));

      // Create a simulation
      const simulation = d3
        .forceSimulation(nodes)
        .force("x", d3.forceX(_width / 2).strength(0.1)) // Center bubbles
        .force("y", d3.forceY(_height / 2).strength(0.1)) // Center bubbles
        .force(
          "collision",
          d3.forceCollide((d) => d.radius + dynamicPadding)
        ) // Add padding
        .force("box", boxForce(0, 0, _width, _height))
        .on("tick", ticked);

      // Custom force to keep nodes inside the rectangle
      function boxForce(x0, y0, x1, y1) {
        return () => {
          nodes.forEach((node) => {
            if (node.x - node.radius < x0) node.x = x0 + node.radius;
            if (node.x + node.radius > x1) node.x = x1 - node.radius;
            if (node.y - node.radius < y0) node.y = y0 + node.radius;
            if (node.y + node.radius > y1) node.y = y1 - node.radius;
          });
        };
      }

      //Draw bar
      const barLine = d3
        .select(element)
        .selectAll(".barline")
        .data(nodes)
        .enter()
        .append("line")
        .attr("stroke", "#BFBFBF")
        .attr("stroke-width", "4")
        .on("mouseover", mouseover)
        .on("mousemove", mousemove)
        .on("mouseout", function () {
          tooltip.style("opacity", 0);
        });

      //Draw barconnetor top
      const barLineTopConnector = d3
        .select(element)
        .selectAll(".line-connector")
        .data(nodes)
        .enter()
        .append("line")
        .attr("stroke", "#BFBFBF")
        .attr("stroke-width", "4")
        .attr("stroke-linecap", "round")
        .on("mouseover", mouseover)
        .on("mousemove", mousemove)
        .on("mouseout", function () {
          tooltip.style("opacity", 0);
        });

      //Draw barconnetor bottom
      const barLineBottomConnector = d3
        .select(element)
        .selectAll(".line-connector")
        .data(nodes)
        .enter()
        .append("line")
        .attr("stroke", "#BFBFBF")
        .attr("stroke-width", "4")
        .attr("stroke-linecap", "round")
        .on("mouseover", mouseover)
        .on("mousemove", mousemove)
        .on("mouseout", function () {
          tooltip.style("opacity", 0);
        });

      // Draw circles with dynamic radius and colors
      const circles = d3
        .select(element)
        .selectAll(".bubble")
        .data(nodes)
        .enter()
        .append("circle")
        .attr("class", "bubble")
        .attr("r", (d) => {
          return d.radius;
        })
        .attr("fill", (d, i) => {
          const salesPersonIndex = legends.salesPerson.findIndex(
            (x) => x.toString() === d.salesPerson.toString()
          );
          return colors[salesPersonIndex];
        })
        .attr("stroke", (d, i) => {
          const salesPersonIndex = legends.salesPerson.findIndex(
            (x) => x.toString() === d.salesPerson.toString()
          );
          return colors[salesPersonIndex];
        })
        .attr("fill-opacity", 0.5)
        .attr("stroke-width", "1")
        .on("mouseover", mouseover)
        .on("mousemove", mousemove)
        .on("mouseout", function () {
          tooltip.style("opacity", 0);
        });

      if (!showHighVisibilityCallouts) {
        // Add labels to display value inside the bubbles
        d3
          .select(element)
          .selectAll(".label")
          .data(nodes)
          .enter()
          .append("text")
          .attr("class", "label")
          .selectAll("tspan")
          .data((d) => {
            const nfObject = new Intl.NumberFormat("en-US");
            const formattedNumber = nfObject.format(d.value);
            const dollarValueText = `$${formattedNumber} (${d.activityCount} slots)`;
            const companyName = d.text;

            return [
              {
                text: companyName,
                isText: true,
                r: d.radius,
                value: d.value,
                salesPerson: d.salesPerson,
                activityCount: d.activityCount,
                organization: d.organization,
              },
              {
                text: dollarValueText,
                activityCount: d.activityCount,
                isText: false,
                r: d.radius,
                value: d.value,
                salesPerson: d.salesPerson,
                organization: d.organization,
              },
            ];
          })
          .enter()
          .append("tspan")
          .attr("fill", "#FFFFFF")
          .style("font-size", function (d) {
            const len = d.text.substring(0, d.r / 3).length;
            let size = d.r / 3;
            size *= 10 / len;
            size += 1;
            const s = d.r / 2 > 16 ? 16 : d.r / 2;
            return s + "px";
          })
          .attr("dy", (d, i) => (i === 0 ? "-0.2em" : "1.1em")) // Offset for multi-line text
          .text((d) => {
            const text = d.text.substring(0, d.r / 3);
            if (d.text.length > text.length) {
              if (d.isText) {
                const acronym = convertTextToAcronym(d.text);
                return acronym;
              } else {
                const dollarValue = Number(d.value);
                const dollarValueText = `$${d3.format(".3~s")(dollarValue)} (${d.activityCount
                  })`;
                return dollarValueText;
              }
            }
            return text;
          })
          .on("mouseover", mouseover)
          .on("mousemove", mousemove)
          .on("mouseout", function () {
            tooltip.style("opacity", 0);
          });
      }

      const calloutGroup = showHighVisibilityCallouts
        ? d3
          .select(element)
          .selectAll(".oos-callout-group")
          .data(nodes)
          .enter()
          .append("g")
          .attr("class", "oos-callout-group")
        : null;

      const calloutLines = calloutGroup
        ? calloutGroup
          .append("polyline")
          .attr("class", "oos-callout-line")
          .style("stroke", (d) => d.calloutColor)
          //.style("stroke-opacity", 0.72)
          .style("stroke-opacity", 1)
          .on("mouseover", mouseover)
          .on("mousemove", mousemove)
          .on("mouseout", function () {
            tooltip.style("opacity", 0);
          })
        : null;

      const calloutLabels = calloutGroup
        ? calloutGroup
          .append("text")
          .attr("class", "oos-callout-label")
          .on("mouseover", mouseover)
          .on("mousemove", mousemove)
          .on("mouseout", function () {
            tooltip.style("opacity", 0);
          })
        : null;

      if (calloutLabels) {
        calloutLabels.each(function (d) {
          const label = d3.select(this);
          const lines = d.calloutLines || [];

          for (let i = 0; i < lines.length; i++) {
            label
              .append("tspan")
              .attr("dy", i === 0 ? "0" : "1.05em")
              .text(lines[i]);
          }
        });

        const _stageName = stages[getElementData.stageIndex];
        const boxOffsetY = -(
          yScale(_stageName) +
          yScale.bandwidth() +
          yScale.bandwidth() * 0.05
        );

        calloutRegistry.push({
          stageIndex: getElementData.stageIndex,
          slotIndex: slots.findIndex((slot) => slot === getElementData.slot),
          rowHeight: _height,
          nodes,
          calloutLines,
          calloutLabels,
          boxOffsetX,
          boxOffsetY,
        });
      }

      // Update positions on each tick
      function ticked() {
        barLine
          .attr("x1", (d) => d.x)
          .attr("x2", (d) => d.x)
          .attr("y1", (d) => d.y - barLineScale(d.activityCount))
          .attr("y2", (d) => d.y + barLineScale(d.activityCount));

        barLineTopConnector
          .attr("x1", (d) => d.x - 3.5)
          .attr("x2", (d) => d.x + 3.5)
          .attr("y1", (d) => d.y - barLineScale(d.activityCount))
          .attr("y2", (d) => d.y - barLineScale(d.activityCount));

        barLineBottomConnector
          .attr("x1", (d) => d.x - 3.5)
          .attr("x2", (d) => d.x + 3.5)
          .attr("y1", (d) => d.y + barLineScale(d.activityCount))
          .attr("y2", (d) => d.y + barLineScale(d.activityCount));

        circles.attr("cx", (d) => d.x).attr("cy", (d) => d.y);

        if (!showHighVisibilityCallouts) {
          d3.select(element)
            .selectAll(".label")
            .data(nodes)
            .attr("x", (d) => d.x)
            .attr("y", (d) => d.y)
            .selectAll("tspan")
            .attr("x", function (d, i, nodes) {
              const parentNode = nodes[i].parentNode.__data__;
              return parentNode.x;
            });
        }

        if (showHighVisibilityCallouts && calloutLines && calloutLabels) {
          updateGlobalCallouts();
        }
      }

      function mousemove(event) {
        const tooltipWidth = tooltip.node().offsetWidth;
        const tooltipHeight = tooltip.node().offsetHeight;

        // Cursor position
        let left = event.pageX + 10;
        let top = event.pageY + 10;

        // Viewport dimensions
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        // Adjust for right edge
        if (left + tooltipWidth > viewportWidth) {
          left = event.pageX - tooltipWidth - 10;
        }

        // Adjust for bottom edge
        if (top + tooltipHeight > viewportHeight) {
          top = event.pageY - tooltipHeight - 10;
        }

        tooltip.style("left", `${left}px`).style("top", `${top}px`);
      }

      function mouseover(event, d) {
        const nfObject = new Intl.NumberFormat("en-US");
        const formattedNumber = nfObject.format(d.value);
        tooltip
          .style("opacity", 1)
          .html(
            `Salesperson: ${d.salesPerson}<br>Opportunity Value: $${formattedNumber}<br>Slots: ${d.activityCount}<br>Organization: ${d.organization}`
          );
      }
    });
  }

  function wrap(text, width) {
    text.each(function () {
      let text = d3.select(this),
        words = text.text().split(/\s+/).reverse(),
        word,
        line = [],
        //lineNumber = 0,
        lineHeight = 1.2, // ems
        x = text.attr("x"),
        y = text.attr("y"),
        dy = 0; // parseFloat(text.attr("dy")),
      let tspan = text
        .text(null)
        .append("tspan")
        .style(
          "font-family",
          '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji'
        )
        .attr("x", x)
        .attr("y", y)
        .attr("dy", dy + "em");
      while ((word = words.pop())) {
        line.push(word);
        tspan.text(line.join(" "));
        if (tspan.node().getComputedTextLength() > width) {
          line.pop();
          tspan.text(line.join(" "));
          line = [word];
          tspan = text
            .append("tspan")
            .style(
              "font-family",
              '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji'
            )
            .attr("x", x)
            .attr("y", y)
            //.attr("dy", ++lineNumber * lineHeight + dy + "em")
            .attr("dy", lineHeight + dy + "em")
            .text(word);
        }
      }
    });
  }

  function convertTextToAcronym(text) {
    const words = text.split(" ");
    let acronyms = "";

    for (const word of words) {
      if (word.length === 0) continue;
      acronyms += word[0];
    }

    return acronyms.toLocaleUpperCase();
  }

  function legendGenerator(_colors, legends) {
    let colorsObj = {};

    colorsObj = _colors;

    let barLegendDOM = "";
    let lineLegendDOM = "";
    const nfObject = new Intl.NumberFormat("en-US");
    const formattedNumber = nfObject.format(legends.text);

    const labelDOM =
      "<div style=\"display:inline-block;margin-left:4px;color:#FFFFFF;font-family: 'Segoe UI', 'Helvetica Neue', 'Trebuchet MS', Verdana;font-weight: 500;font-size: 14px;\">Closed Won Value: ".concat(
        `$${formattedNumber}`,
        "</div>"
      );
    barLegendDOM += "<div class='legendBoxContent'>".concat(labelDOM, "</div>");

    barLegendDOM =
      "<div class='barLegendBox' style=\"flex-basis: 50% !important;justify-content: flex-start;\">".concat(
        barLegendDOM,
        "</div>"
      );

    if (legends.salesPerson.length > 0) {
      for (let j = 0; j < legends.salesPerson.length; j++) {
        let _color = colorsObj[j];

        const _boxDOM =
          '<div style="display:inline-block;width:14px;height:14px;border-radius:6px;background:'.concat(
            _color,
            '"></div>'
          );
        const _labelDOM =
          "<div style=\"display:inline-block;margin-left:4px;color:#FFFFFF;font-family: 'Segoe UI', 'Helvetica Neue', 'Trebuchet MS', Verdana;font-weight: 400;font-size: 14px;\">".concat(
            legends.salesPerson[j],
            "</div>"
          );
        lineLegendDOM +=
          '<div style="display:flex;align-items:center;margin-right:10px;padding-bottom:5px;">'
            .concat(_boxDOM)
            .concat(_labelDOM, "</div>");
      }
    }

    lineLegendDOM =
      '<div style="display:flex;flex-wrap: wrap;flex-basis:50%;justify-content:flex-end;">'.concat(
        lineLegendDOM,
        "</div>"
      );

    let legendHtml =
      '<div style="display:flex;flex-wrap: wrap;box-sizing: border-box;">'
        .concat(barLegendDOM)
        .concat(lineLegendDOM, "</div>");

    return legendHtml;
  }

  return { draw: drawChart };
};

const OOSD3Component = ({
  widgetId,
  widgetDt,
  height,
  width,
  getWidgetSize,
  wid,
  slots,
  xAxisMax,
  wonDollarValue,
  salesPersons,
  stages,
  collorPallet,
  showHighVisibilityCallouts,
}) => {
  const d3Container = useRef(null);
  const [backgroundColor, setBackgroundColor] = useState("");
  const adjustedHeight = height - Margin.TOP - Margin.BOTTOM;
  const adjustedWidth = width - Margin.RIGHT - Margin.LEFT;
  const isTopBarHide = useSelector((state) => state.layout.IsHeaderDisplayed);

  useEffect(() => {
    getWidgetSize();

    if (!_.isEmpty(widgetDt) && height > 0 && width > 0) {
      const svg = d3.select(d3Container.current);

      // try {
      //   console.log("widgetDt", widgetDt);
      //   widgetDt = sampleDataWithOverlapped;
      //   widgetDt = sampleDataWithSingleBubble;
      //   widgetDt = sampleDataWithSingleDiffBubble;
      //   widgetDt = OOSDt15Overlap;
      //   widgetDt = OOSDt15OverlapWon;
      //   widgetDt = OOSDt10;

      //   stages = widgetDt.map((x) => x.stageName);

      //   console.log("widgetDt1", widgetDt);
      //   wonDollarValue = widgetDt
      //     .find((x) => x.stageName.toLowerCase() === "won")
      //     .bubbles.map((x) => x.dollarValue)
      //     .reduce((prev, next) => prev + next);
      //   console.log("wonDollarValue", wonDollarValue);
      // } catch (error) {
      //   wonDollarValue = 0;
      // }
      // console.log("slots", slots);

      const chart = OOSWidget(
        svg,
        widgetId,
        adjustedHeight,
        adjustedWidth,
        slots,
        xAxisMax,
        wonDollarValue,
        salesPersons,
        collorPallet,
        showHighVisibilityCallouts
      );

      //chart.draw(sampleData55, stages);
      //chart.draw(sampleDataWithOverlapped, stages);
      //chart.draw(OOSDt15Overlap, stages);
      //chart.draw(OOSDt15OverlapWon, stages);
      //chart.draw(sampleData40, stages);
      //chart.draw(sampleDataWithSingleBubble, stages);
      //chart.draw(sampleData30, stages);
      chart.draw(widgetDt, stages);
      //chart.draw(OOSDt, stages);
      //chart.draw(OOSDt10, stages);

      const backgroundColor1 = slots.length % 2 === 0 ? "#3F3F3F" : "#595959";
      setBackgroundColor(backgroundColor1);
    }
  }, [
    widgetDt,
    height,
    width,
    wid,
    slots,
    xAxisMax,
    wonDollarValue,
    salesPersons,
    stages,
    collorPallet,
    showHighVisibilityCallouts,
    isTopBarHide,
  ]);

  return (
    <Fragment>
      <div id={widgetId} className="ooswidget">
        <div
          id={`${widgetId}-dom-legend`}
          data-elementid={widgetId}
          style={{
            padding: "5px 0",
            background: backgroundColor,
          }}
        ></div>
        <svg ref={d3Container} height={height} width={width}></svg>
      </div>
    </Fragment>
  );
};

export default OOSD3Component;
